import React from "react";
import PropTypes from "prop-types";
import { RadioGroupField } from "components/form";
import { STATES } from "utils/enum";
import { useFormikContext, Field } from "formik";
import FormElement from "./form-elements";
import useTranslate from "hooks/use-translate-language";
import { isValidZip } from "utils/misc";
import Switch from "components/ui_new/switch";
import { TextInput, SelectInput } from "components/form_new";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import "./styles.scss";

const AddressForm = ({ patientInfo, questions }) => {
  const translate = useTranslate();
  const { values, setFieldValue } = useFormikContext();

  React.useEffect(() => {
    if (values.questions.address_change === false) {
      setFieldValue("address", patientInfo.address);
    }
  }, [values.questions.address_change]);

  const address_change_question = questions.find(
    q => q.id === "address_change"
  );

  if (!address_change_question) {
    return null;
  }

  const disabled = !values.questions.address_change;

  return (
    <div>
      <div style={{marginTop:'30px'}}>
      <div style={{ display: "flex", flexDirection: "row", marginTop: "2%", marginBottom:'2%' }}>
        <span style={{ marginRight: "5px" }}>
          {translate("addressChanged")}
        </span>
        <Switch
          name="questions.address_change"
          checked={values.questions.address_change}
          onChange={e => setFieldValue("questions.address_change", e.target.checked)}
          inputProps={{ "aria-label": address_change_question?.text || translate("addressChanged") }}
        />
      </div>
        <div style={{ paddingBottom: 20, minHeight: 30 }}>
          {values.questions?.address_change && (
            <div style={{ display: "flex", alignItems: "center" }}>

            <Field
              component={RadioGroupField}
              name="address_change_type"
              label=""
              value={values.address_change_type}
              required
              options={[
                { value: "P", text: "Permanent Address Change" },
                { value: "T", text: "Temporary Address Change" }
              ]}
              />
              {!values.address_change_type && (
                <div
                  id="address-change-type-inline-error"
                  role="alert"
                  aria-live="polite"
                  style={{ color: "red", marginLeft: "8px" }}
                >
                  Required
                </div>
              )}
              </div>
          )}
        </div>
      </div>
      <div className="questions-container">
      <TextInput
        name="address.street_address"
        label={translate("streetAddress")}
        disabled={disabled}
      />
      <TextInput
        name="address.street_address2"
        label={translate("streetAddress2")}
        disabled={disabled}
      />
      <TextInput
        name="address.city"
        label={translate("city")}
        disabled={disabled}
      />
      <SelectInput
        name="address.state"
        label={translate("state")}
        options={STATES}
        disabled={disabled}
        IconComponent={KeyboardArrowDownIcon}
      />
      <TextInput
        name="address.zip"
        label={translate("zip")}
        disabled={disabled}
        validate={isValidZip}
        type="number"
      />
      <div>
        {questions
          ?.filter(x => x.id != "address_change")
          ?.map(x => (
            <FormElement key={x.id} {...x} />
          ))}
      </div>
      </div>
    </div>
  );
};

export default AddressForm;

AddressForm.propTypes = {
  patientInfo: PropTypes.shape({
    address: PropTypes.shape({
      street_address: PropTypes.string,
      street_addres2: PropTypes.string,
      city: PropTypes.string,
      zip: PropTypes.string
    }).isRequired
  }).isRequired,
  questions: PropTypes.array.isRequired
};
